<template>
  <div class="w-100">
    <div class="px-0 d-flex me-4" style="place-items: center">
      <span class="fsize-16 me-3">Refund Status</span>
      <select v-model="selected" class="p-2">
        <option v-for="data in listStatus" :key="data.id" :value="data">
          {{ data.value }}
        </option>
      </select>
    </div>
    <ApprovedPage v-if="selected.id === 'REFUNDED'"/>
    <RejectPage v-else-if="selected.id === 'REJECTED'"/>
    <PendingPage v-else/>
  </div>
</template>

<script>
import PendingPage from "./Pending.vue";
import ApprovedPage from "./Approved.vue";
import RejectPage from "./Reject.vue";

export default {
  components: {
    PendingPage,
    ApprovedPage,
    RejectPage,
  },
  data() {
    return {
      selected: {value: "Pending Refunds", id: "PENDING"},
      listStatus: [
        {value: "Pending Refunds", id: "PENDING"},
        {value: "Refunded Refunds", id: "REFUNDED"},
        {value: "Rejected Refunds", id: "REJECTED"},
      ],
    };
  },
  methods: {
  },
};
</script>

<style></style>
